import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFashion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFashion"><Path d="M9.64338 3.53004L9.38601 2.69141L0.820312 6.8698L2.85636 11.5996L5.00139 10.6181V21.0001H19.0014V10.6181L21.1464 11.5996L23.1825 6.8698L14.6168 2.69141L14.3594 3.53004C13.953 4.85441 12.9516 5.44842 12.0014 5.44842C11.0512 5.44842 10.0498 4.85441 9.64338 3.53004Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFashion;
